module.exports = __webpack_public_path__ + "static/img/2672_phase_function_Paper_Points.c920d74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2672_phase_function_Paper_Points.png
// module id = aiuA
// module chunks = 0